import { render, staticRenderFns } from "./kr-date.vue?vue&type=template&id=2ce0d14c&scoped=true&"
import script from "./kr-date.vue?vue&type=script&lang=js&"
export * from "./kr-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce0d14c",
  null
  
)

export default component.exports